
styles += """
[data-widget="UpgradeForumBanner"], [data-widget="HostHeader"].forum_editor {
  background-color: #456ae4;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23003f99' fill-opacity='0.49' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
  width: 100%;
}

[data-widget="HostHeader"].forum_editor.not-fixed {
  position: relative;
}


[data-widget="HostHeader"].forum_editor.fixed {
  position: fixed;
  z-index: 99998;
}


#DASHBOARD-main [data-widget="UpgradeForumButton"] .btn.big, [data-widget="UpgradeForumButton"] .btn.big {
  text-transform: capitalize;
  padding: 8px 24px;
  font-size: 14px;
  margin-left: 0px;
  margin-bottom: 24px;
  box-shadow: 0 1px 1px rgb(8 81 114);
}

#DASHBOARD-main [data-widget="UpgradeForumButton"] .btn, [data-widget="UpgradeForumButton"] .btn {
  margin-left: 8px;
  background-color: #{upgrade_color};
  font-size: 10px;
  padding: 4px 6px;
  text-transform: lowercase;
}
"""


window.UpgradeForumButton = ReactiveComponent
  displayName: 'UpgradeForumButton'

  render: -> 
    TAG = @props.tag or BUTTON

    SPAN null, 
      TAG
        className: "btn #{if @props.big then 'big' else ''}"
        style: @props.style or {}

        onClick: => 
          @local.show_payment_form = true 
          save @local

        @props.text or "upgrade"

      if @local.show_payment_form
        ModalStripePayment
          cancel_payment: =>
            @local.show_payment_form = false 
            save @local

window.UpgradeForumBanner = ReactiveComponent
  displayName: 'UpgradeForumBanner'

  render: ->
    region = bus_fetch('/application').region

    if region == 'EU'
      amount = "€655"
    else if region == 'CA'
      amount = "CA$1000"
    else 
      amount = "$750"

    DIV 
      style: 
        display: 'flex'
        justifyContent: 'center'
        alignItems: 'center'
        padding: 4


      BUTTON
        className: 'btn'
        style: 
          marginRight: 24
          backgroundColor: upgrade_color # selected_color
          boxShadow: '0 1px 2px rgba(0,0,0,.5)'


        onClick: => 
          @local.show_payment_form = true 
          save @local

        "Upgrade forum"


      SPAN 
        style: 
          fontSize: 13
          color: 'white'
          fontWeight: 700
        if WINDOW_WIDTH() < 956
          "#{amount} one-time fee"
        else
          "#{amount} one-time fee to unlock data export, sign-up questions, tab-based organization, and more."
      
        A 
          href: "https://#{bus_fetch('/application').base_domain}/pricing"
          target: '_blank'
          style: 
            textDecoration: 'underline'
            paddingLeft: 12
            color: 'white'
            fontWeight: 700
            fontSize: 15

          "Learn more"

      if @local.show_payment_form
        ModalStripePayment
          cancel_payment: =>
            @local.show_payment_form = false 
            save @local

window.UpgradeForumCompact = ReactiveComponent
  displayName: 'UpgradeForumCompact'

  render: ->
    region = bus_fetch('/application').region
    
    if region == 'EU'
      amount = "€655"
    else if region == 'CA'
      amount = "CA$1000"
    else 
      amount = "$750"

    DIV 
      style: 
        position: 'absolute'

      BUTTON
        className: 'btn'
        title: "#{amount} one-time fee to unlock data export, sign-up questions, tab-based organization, and more."
        style: 
          backgroundColor: upgrade_color # selected_color

          boxShadow: '0 1px 2px rgba(0,0,0,.5)'
          # display: 'block'

        onClick: => 
          @local.show_payment_form = true 
          save @local

        "Upgrade forum"

      A 
        href: "https://#{bus_fetch('/application').base_domain}/pricing"
        target: '_blank'
        style: 
          textDecoration: 'underline'
          color: 'white'
          fontWeight: 600
          fontSize: 13
          marginLeft: 24

        "Learn more about our plans"      


      if @local.show_payment_form
        ModalStripePayment
          cancel_payment: =>
            @local.show_payment_form = false 
            save @local






styles += """
  [data-widget="ModalStripePayment"] #modal-body {
    background-color: white;
    padding: 64px 0 48px 0;
  }
  [data-widget="ModalStripePayment"] #modal-body #payment-form {
    box-shadow: none;
    padding: 0;
  }
"""

window.ModalStripePayment = ReactiveComponent
  displayName: 'ModalStripePayment'
  mixins: [Modal]

  render: ->
    
    cancel_payment = =>
      @props.cancel_payment?()

    wrap_in_modal Math.min(700, HOMEPAGE_WIDTH()), cancel_payment, DIV null,
      STRIPE_PAYMENT(@props)

      if @props.cancel_payment?
        BUTTON 
          className: 'like_link'
          style: 
            opacity: .7
            textAlign: 'center'
            display: 'block'
            margin: '24px auto 0 auto'
            # textDecoration: 'none'

          onClick: cancel_payment

          'cancel'


stripeSVG = (props) -> 

  base_width = 150
  base_height = 34

  svg.setSize base_width, base_height, props

  style = props.style or {}

  SVG
    width: props.width 
    height: props.height
    viewBox: "0 0 #{base_width} #{base_height}" 
    version: "1.1" 
    xmlns: "http://www.w3.org/2000/svg" 
    style: style

    dangerouslySetInnerHTML: __html: """
      <g fill="#635bff"><path d="m146 0h-142.27a3.73 3.73 0 0 0 -3.73 3.73v26.54a3.73 3.73 0 0 0 3.73 3.73h142.27a4 4 0 0 0 4-4v-26a4 4 0 0 0 -4-4zm3 30a3 3 0 0 1 -3 3h-142.27a2.74 2.74 0 0 1 -2.73-2.73v-26.54a2.74 2.74 0 0 1 2.73-2.73h142.27a3 3 0 0 1 3 3z"/><path d="m17.07 11.24h-4.3v10.76h1.92v-4.16h2.38c2.4 0 3.9-1.16 3.9-3.3s-1.5-3.3-3.9-3.3zm-.1 5h-2.28v-3.3h2.31c1.38 0 2.11.59 2.11 1.65s-.76 1.6-2.11 1.6z"/><path d="m25.1 14a3.77 3.77 0 0 0 -3.8 4.09 3.81 3.81 0 1 0 7.59 0 3.76 3.76 0 0 0 -3.79-4.09zm0 6.67c-1.22 0-2-1-2-2.58s.76-2.58 2-2.58 2 1 2 2.58-.79 2.57-2 2.57z"/><path d="m36.78 19.35-1.41-5.22h-1.48l-1.4 5.22-1.42-5.22h-1.85l2.37 7.88h1.56l1.44-5.16 1.44 5.16h1.56l2.37-7.88h-1.78z"/><path d="m44 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.41-2.18l-1.49-.62a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.17-2.17h5.52v-.6c.02-2.16-1.2-3.87-3.52-3.87zm-1.93 3.13a1.92 1.92 0 0 1 1.93-1.63 1.56 1.56 0 0 1 1.69 1.62z"/><path d="m50.69 15.3v-1.17h-1.8v7.87h1.8v-4.13a1.89 1.89 0 0 1 2-2 4.68 4.68 0 0 1 .66 0v-1.8c-.14 0-.3 0-.51 0a2.29 2.29 0 0 0 -2.15 1.23z"/><path d="m57.48 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.37-2.18l-1.54-.59a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.1-2.17h5.54v-.6c0-2.19-1.24-3.9-3.52-3.9zm-1.93 3.13a1.92 1.92 0 0 1 1.92-1.62 1.56 1.56 0 0 1 1.69 1.62z"/><path d="m67.56 15a2.85 2.85 0 0 0 -2.26-1c-2.21 0-3.47 1.85-3.47 4.09s1.26 4.09 3.47 4.09a2.82 2.82 0 0 0 2.26-1v.82h1.8v-10.76h-1.8zm0 3.35a2 2 0 0 1 -2 2.28c-1.31 0-2-1-2-2.52s.7-2.52 2-2.52c1.11 0 2 .81 2 2.29z"/><path d="m79.31 14a2.88 2.88 0 0 0 -2.31 1v-3.76h-1.8v10.76h1.8v-.83a2.86 2.86 0 0 0 2.27 1c2.2 0 3.46-1.86 3.46-4.09s-1.22-4.08-3.42-4.08zm-.31 6.6a2 2 0 0 1 -2-2.28v-.47c0-1.48.84-2.29 2-2.29 1.3 0 2 1 2 2.52s-.75 2.52-2 2.52z"/><path d="m86.93 19.66-1.93-5.53h-1.9l2.9 7.59-.3.74a1 1 0 0 1 -1.14.79 4.12 4.12 0 0 1 -.6 0v1.51a4.62 4.62 0 0 0 .73.05 2.67 2.67 0 0 0 2.78-2l3.24-8.62h-1.89z"/><path d="m125 12.43a3 3 0 0 0 -2.13.87l-.14-.69h-2.39v12.92l2.72-.59v-3.13a3 3 0 0 0 1.93.7c1.94 0 3.72-1.59 3.72-5.11 0-3.22-1.8-4.97-3.71-4.97zm-.65 7.63a1.61 1.61 0 0 1 -1.28-.52v-4.11a1.64 1.64 0 0 1 1.3-.55c1 0 1.68 1.13 1.68 2.58s-.69 2.6-1.7 2.6z"/><path d="m133.73 12.43c-2.62 0-4.21 2.26-4.21 5.11 0 3.37 1.88 5.08 4.56 5.08a6.12 6.12 0 0 0 3-.73v-2.25a5.79 5.79 0 0 1 -2.7.62c-1.08 0-2-.39-2.14-1.7h5.38c0-.15 0-.74 0-1 .09-2.87-1.27-5.13-3.89-5.13zm-1.47 4.07c0-1.26.77-1.79 1.45-1.79s1.4.53 1.4 1.79z"/><path d="m113 13.36-.17-.82h-2.32v9.71h2.68v-6.58a1.87 1.87 0 0 1 2.05-.58v-2.55a1.8 1.8 0 0 0 -2.24.82z"/><path d="m99.46 15.46c0-.44.36-.61.93-.61a5.9 5.9 0 0 1 2.7.72v-2.63a7 7 0 0 0 -2.7-.51c-2.21 0-3.68 1.18-3.68 3.16 0 3.1 4.14 2.6 4.14 3.93 0 .52-.44.69-1 .69a6.78 6.78 0 0 1 -3-.9v2.69a7.38 7.38 0 0 0 3 .64c2.26 0 3.82-1.15 3.82-3.16-.05-3.36-4.21-2.76-4.21-4.02z"/><path d="m107.28 10.24-2.65.58v8.93a2.77 2.77 0 0 0 2.82 2.87 4.16 4.16 0 0 0 1.91-.37v-2.25c-.35.15-2.06.66-2.06-1v-4h2.06v-2.34h-2.06z"/><path d="m116.25 11.7 2.73-.57v-2.16l-2.73.57z"/><path d="m116.25 12.61h2.73v9.64h-2.73z"/></g></svg>
    """


# adapted from https://stripe.com/docs/payments/quickstart

window.STRIPE_PAYMENT = ReactiveComponent
  displayName: 'STRIPE_PAYMENT'

  componentDidMount: -> 

    @configurePayment()

  componentDidUpdate: -> 
    @configurePayment()

  render: -> 

    region = bus_fetch('/application').region

    if region == 'EU'
      amount = "€655"
    else if region == 'CA'
      amount = "CA$1000"
    else 
      amount = "$750"

    DIV null, 

      DIV 
        style:
          marginBottom: 48 
          color: 'black'

        H1
          style: 
            fontSize: 32
            textAlign: 'center'

          "Upgrade to a Premium Forum"



        DIV 
          style:
            fontSize: 13
            margin: "12px auto"
            maxWidth: 500


          "#{amount} one-time fee to unlock data export, sign-up questions, and tab-based organization. Contact"

          A
            href: 'mailto:help@consider.it?subject=Consider.it alternative payment'
            style: 
              textDecoration: 'underline'
              padding: "0px 4px"
              fontWeight: 600
            'help@consider.it'
          "to pay using a different method."



      stripeSVG
        height: 24
        style: 
          position: 'absolute'
          right: 90
          bottom: 48

      DIV 
        style: 
          display: 'flex'
          justifyContent: 'center'

        FORM 
          id: "payment-form"
          ref: "payment_form"

          DIV 
            id: "payment-element"

            if @local.loading
              LOADING_INDICATOR

          BUTTON 
            id: "submit"

            DIV 
              className: "spinner hidden"
              id: "spinner"
            SPAN 
              id: 'button-text'
              "Pay now"
          DIV 
            id: "payment-message"
            className: "hidden"


  configurePayment: -> 

    # lazy load stripe

    stripe_script_loaded = lazyLoadJavascript "https://js.stripe.com/v3/", 
      onload: => 
        @local.loading = false 
        save @local
      onerror: => 
        @local.error = true
        @local.loading = false 
        save @local      

    if !stripe_script_loaded && !@local.error
      @local.loading = true 
      save @local
      return

    if !Stripe?
      return setTimeout @configurePayment, 20

    if !window.stripe
      pub = bus_fetch '/payments/public_key'
      return if !pub.public_key
      window.stripe = Stripe(pub.public_key)

    if !@intent 
      intent = bus_fetch '/payments/payment_intent'
      return if !intent.secret
      @intent = intent.secret

    if !@mounted
      appearance =
        theme: 'stripe'

      elements = stripe.elements { appearance, clientSecret: @intent }

      paymentElement = elements.create "payment", 
        business: 
          name: "Consider.it"
      paymentElement.mount("#payment-element")

      @mounted = true 

      payment_form = @refs.payment_form

      setLoading = (isLoading) ->
        if isLoading
          payment_form.querySelector("#submit").disabled = true
          payment_form.querySelector("#spinner").classList.remove("hidden")
          payment_form.querySelector("#button-text").classList.add("hidden")
        else
          payment_form.querySelector("#submit").disabled = false
          payment_form.querySelector("#spinner").classList.add("hidden")
          payment_form.querySelector("#button-text").classList.remove("hidden")
      
      showMessage = (messageText) =>
        messageContainer = payment_form.querySelector("#payment-message")
        messageContainer.classList.remove("hidden")
        messageContainer.textContent = messageText

        setTimeout ->
          messageContainer.classList.add("hidden")
          messageText.textContent = ""
        , 4000

      checkStatus = =>

        stripe.retrievePaymentIntent(@intent)
          .then ({paymentIntent}) =>

            switch paymentIntent.status

              when "succeeded"
                showMessage("Payment succeeded!")
                break

              when "processing"
                showMessage("Your payment is processing.")
                break

              when "requires_payment_method"
                showMessage("Your payment was not successful, please try again.")
                break

              else
                showMessage("Something went wrong.")
                break



      
      payment_form 
        .addEventListener "submit", (e) =>
          # checkStatus()
          
          e.preventDefault()
          setLoading true

          promise = stripe.confirmPayment
            elements: elements
            confirmParams:
              return_url: if @props.create_forum_after_payment 
                            url = "#{location.origin}/payments/successful?create_forum=#{@props.create_forum_after_payment}"
                            if @props.copy_from
                              url += "&copy_from=#{@props.copy_from}"
                            url
                          else 
                            url = new URL(window.location.href)
                            if bus_fetch('edit_forum').editing
                              url.searchParams.set('edit_forum', 'true')
                            url.searchParams.set('flash', translator('admin.thanks-for-upgrading', 'Thank you for upgrading!'))
                            "#{location.origin}/payments/successful?redirect_to=#{encodeURIComponent(url.href)}"

          promise.then ({error }) =>
            # This point will only be reached if there is an immediate error when
            # confirming the payment. Otherwise, your customer will be redirected to
            # your `return_url`. For some payment methods like iDEAL, your customer will
            # be redirected to an intermediate site first to authorize the payment, then
            # redirected to the `return_url`.
            if error.type == "card_error" || error.type == "validation_error"
              showMessage(error.message)
            else
              showMessage("An unexpected error occured.")

            setLoading(false)


styles += """
  #payment-form {
    width: 30vw;
    min-width: 500px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
      0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
    background-color: white;
  }

  #payment-form * {
    box-sizing: border-box;
  }

  #payment-form body {
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    display: flex;
    justify-content: center;
    align-content: center;
    height: 100vh;
    width: 100vw;
  }

  #payment-form .hidden {
    display: none;
  }

  #payment-message {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
  }

  #payment-element {
    margin-bottom: 24px;
  }

  /* Buttons and links */
  #payment-form button {
    background: #5469d4;
    font-family: Arial, sans-serif;
    color: #ffffff;
    border-radius: 4px;
    border: 0;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
  }
  #payment-form button:hover,
  #payment-form button:focus-within {
    filter: contrast(115%);
  }
  #payment-form button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* spinner/processing state, errors */
  #payment-form .spinner,
  #payment-form .spinner:before,
  #payment-form .spinner:after {
    border-radius: 50%;
  }
  #payment-form .spinner {
    color: #ffffff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #payment-form .spinner:before,
  #payment-form .spinner:after {
    position: absolute;
    content: "";
  }
  #payment-form .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: payment-loading 2s infinite ease 1.5s;
    animation: payment-loading 2s infinite ease 1.5s;
  }
  #payment-form .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: payment-loading 2s infinite ease;
    animation: payment-loading 2s infinite ease;
  }

  @-webkit-keyframes payment-loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes payment-loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @media (max-width: 600px) {
    #payment-form form {
      width: 80vw;
      min-width: initial;
    }
  }



"""





/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/payment.coffee
 **/